<template>

  <ControlloFattureFornitoriGAS />
 
</template>

<script>
import ControlloFattureFornitoriGAS from '../components/pratiche/ControlloFattureFornitoriGAS.vue'

export default {
  pageName: 'fatture',
  components: {
    ControlloFattureFornitoriGAS

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
